import { PackageEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { CAR_CURRENCY } from '@shared/constants'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps, MAX_ADDITIONAL_EQUIPMENT } from './utils'

export const AdditionalEquipment = () => {
  const { t } = useTranslation()
  const {
    insuredAmountProps,
    additionalEquipmentDescriptionProps,
    additionalEquipmentAmountProps,
    insurancePackageProps,
    fiftyFiftyFullProps
  } = formProps(t)
  const { required } = useValidationsField()
  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })
  const fiftyFiftyFull = Form.useWatch(fiftyFiftyFullProps.name, {
    preserve: true
  })

  const additionalEquipmentDescription = Form.useWatch(
    additionalEquipmentDescriptionProps.name
  )
  const insuredAmount = Form.useWatch(insuredAmountProps.name, {
    preserve: true
  })

  if (insurancePackage === PackageEnum.MINI) return null

  const maxAdditionalEquipmentAmount =
    (insuredAmount * MAX_ADDITIONAL_EQUIPMENT) / 100

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={12}>
        <Form.Item {...additionalEquipmentDescriptionProps}>
          <Input.TextArea
            disabled={fiftyFiftyFull}
            autoSize
            placeholder={additionalEquipmentDescriptionProps.label}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item
          {...additionalEquipmentAmountProps}
          rules={additionalEquipmentDescription ? [required] : []}
        >
          <InputParsedNumber
            disabled={!additionalEquipmentDescription || fiftyFiftyFull}
            placeholder={additionalEquipmentAmountProps.label}
            suffix={CAR_CURRENCY}
            max={maxAdditionalEquipmentAmount}
            className="w-full"
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
